cb.define([], function () {
  var AA_aa_billTemplate_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
    	// 加载数据
    	// 1、编辑态时，公共模板，点编辑按钮，不显示适用组织
    	// 2、编辑态时，组织模板，点编辑按钮，显示适用组织
    	// 3、浏览态时，公共模板，显示恢复默认按钮，不显示适用组织
    	// 4、浏览态时，组织模板，不显示恢复默认按钮，显示适用组织和删除按钮
    	viewmodel.on('recover', function (){
    		cb.utils.confirm(`是否恢复默认？`, function(){
    		var templateId = viewmodel.get('id').getValue();
    		var proxy = cb.rest.DynamicProxy.create({
    			recover: {url: '/billTemplateSet/recoverDefault', method: 'GET'}
    		});
    		proxy.recover({templateId}, function (err, result){
    			if (err) {
    				cb.utils.alert(err.message, 'error');
    				return;
    			}
    			cb.utils.alert('恢复默认成功', 'success');
    			viewmodel.communication({type:'return'});
    		});
    		});
    	});
    	viewmodel.on('afterLoadData', function() {
    		var mode = viewmodel.getParams().mode;
    		if (mode == "browse")
    		{
    			if(viewmodel.get('templateType').getValue() == '1')
    		  {
    			   viewmodel.get('btnRecoverDefault').setVisible(true);
    			   viewmodel.get('btnDelete').setVisible(false);
    			   viewmodel.execute('updateViewMeta', { code:'aa_orgTemplateScan', visible: false });
    			}
    		  if(viewmodel.get('templateType').getValue() == '2')
    		  {
    			   viewmodel.get('btnRecoverDefault').setVisible(false);
    			   viewmodel.get('btnDelete').setVisible(true);
    			}
    		}
    		if(mode == "edit")
    		{
          viewmodel.get('ShowLines').setState('orderField', 'orderBy');//排序，上移下移
          viewmodel.get('ShowLines').setDirty(true);
          viewmodel.get('BillFunctionKeys').setState('orderField', 'orderBy');
          viewmodel.get('BillFunctionKeys').setDirty(true);
          viewmodel.get('PayFunctionKeys').setState('orderField', 'orderBy');
          viewmodel.get('PayFunctionKeys').setDirty(true);
          viewmodel.get('ShowLines').getEditRowModel().get('board').setState('min', 1);//设置宽度值最小为1
    			//点复制，进入编辑态时，修改模板类型，复制的新组织模板name置空
    			if("copy"== viewmodel.getParams().action)
    			{
    				 viewmodel.get('templateType').setValue('2');
    				 viewmodel.get('name').setValue(null);
    			}
    			//viewmodel.get('btnRecoverDefault').setVisible(false);
    		   if(viewmodel.get('templateType').getValue() == '1')
    		   {
    			    viewmodel.get('code').setReadOnly(true);
    			    viewmodel.get('name').setReadOnly(true);
    			    viewmodel.execute('updateViewMeta', { code:'aa_orgTemplateEdit', visible: false });
    		   }
    		   if(viewmodel.get('templateType').getValue() == '2')
    		   {
    			    viewmodel.execute('updateViewMeta', {code: 'aa_orgTemplateEdit', visible: true});
    		   }

    		   //1、订货、退货、挂单只能修改名称，开单、退款不显示
    		   //2、开单功能键中，开单按钮部分始终启用
    		   //3、开单功能键中，快速收款方式始终启用，且名称不能修改
    		   var billFunctionKeysModel = viewmodel.get('BillFunctionKeys');
    		   var billFunctionKeyRows = billFunctionKeysModel.getRows();
    		   billFunctionKeyRows.forEach(function(row, index){
    			    if (row.paymethodId) {
    				     billFunctionKeysModel.setCellState(index, 'isEnable', 'disabled', true);
    				     billFunctionKeysModel.setCellState(index, 'name', 'disabled', true);
    			    }
    			    else
    			    {
    			    	if (row.command == 'VIPEnterDiscount' || row.command == 'EnterItem' ||
    			        row.command == 'BackItem' || row.command == 'ChooseStandard' ||
    			        row.command == 'DeleteRow' || row.command == 'Settle' || row.command == 'DeleteZero')
    			    	{
    			    	  billFunctionKeysModel.setCellState(index, 'isEnable', 'disabled', true);
    			      }
    			      if(row.command == 'OrderBill' || row.command == 'BackBill' || row.command == 'ResumeReceipt')
    			      {
    			        billFunctionKeysModel.setCellState(index, 'isEnable', 'disabled', true);
    			        billFunctionKeysModel.setCellState(index, 'hotKey', 'disabled', true);
    			      }
    			    }
    		   })
    		   //4、收款功能键，只能修改快捷键
    		   var payFunctionKeysModel = viewmodel.get('PayFunctionKeys');
    		   var payRows = payFunctionKeysModel.getRows();
    		   payRows.forEach(function(row, index){
    			       payFunctionKeysModel.setCellState(index, 'name', 'disabled', true);
    		   })
    		}
     });
      // 复制事件后
      // 公共或组织模板，点复制，显示适用组织
      viewmodel.on('afterCopy',function() {
     	  //viewmodel.get('btnRecoverDefault').setVisible(false);
     	  viewmodel.execute('updateViewMeta', {code: 'aa_orgTemplateEdit', visible:true});
     });
   }
  }
  try {
    module.exports = AA_aa_billTemplate_VM_Extend;
  } catch (error) {

  }
  return AA_aa_billTemplate_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_billTemplate_VM.Extend.js